// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XUTp","tabsBox":"styles_tabsBox__JlU_B","createButton":"styles_createButton__30gqU"};